const React = require('react');

const cancelScrollEvent = function (e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    e.returnValue = false;
    return false;
};

const addScrollEventListener = function (elem, handler) {
    elem.addEventListener('wheel', handler, false);
};

const removeScrollEventListener = function (elem, handler) {
    elem.removeEventListener('wheel', handler, false);
};

const ScrollLockMixin = {
    scrollLock(elem) {
        elem = elem || this.getDOMNode();
        this.scrollElem = elem;
        addScrollEventListener(elem, this.onScrollHandler);
    },

    scrollRelease(elem) {
        elem = elem || this.scrollElem;
        removeScrollEventListener(elem, this.onScrollHandler);
    },

    onScrollHandler(e) {
        let elem = this.scrollElem;
        let scrollTop = elem.scrollTop;
        let scrollHeight = elem.scrollHeight;
        let height = elem.clientHeight;
        let wheelDelta = e.deltaY;
        let isDeltaPositive = wheelDelta > 0;

        if (isDeltaPositive && wheelDelta > scrollHeight - height - scrollTop) {
            elem.scrollTop = scrollHeight;
            return cancelScrollEvent(e);
        }
        else if (!isDeltaPositive && -wheelDelta > scrollTop) {
            elem.scrollTop = 0;
            return cancelScrollEvent(e);
        }
    }
};


let ScrollLock = React.createClass({displayName: "ScrollLock",
    mixins: [ScrollLockMixin],

    componentDidMount() {
        this.scrollLock();
    },

    componentWillUnmount() {
        this.scrollRelease();
    },

    // show nothing because is just rendering
    render() {
        return (React.createElement("span", null));
    }
});

module.exports = ScrollLock;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/ScrollLock/ScrollLock.js
 **/